import { warehouseApis } from '@apis/dashboard/warehouseApis';
import { createUseQuery } from '@hooks/createUseQuery';
import { WarehouseQuery } from '@models/Warehouse';

export const useWarehouses = createUseQuery(
  (query: WarehouseQuery) => ['/dashboard/warehouse/', query],
  (query: WarehouseQuery) => () =>
    warehouseApis.get('/dashboard/warehouse/', { query }).then((r) => r[200]!),
);
